"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { Switch } from '../../ui-kit/switch.mjs';

function Toggle(props) {
  return /* @__PURE__ */ jsx(Switch, { ...props, size: "md" });
}

export { Toggle };
